<script setup lang="ts">
import {AxiosError, AxiosResponse} from 'axios';
import {useField, useForm} from 'vee-validate';
import {ref} from 'vue';
import * as yup from 'yup';
import ThemeToggleFab from './components/ThemeToggleFab.vue';
import BrandedLogo from './components/BrandedLogo.vue';
import {ThemeInstance, useTheme} from 'vuetify';
import AuthLayout from "./layouts/AuthLayout.vue";
import api from "./api.ts";

const theme: ThemeInstance = useTheme();


interface IFormData {
  username: string;
  email: string;
}

const schema = yup.object({
  username: yup.string().required("Username is required"),
  email: yup.string().email().required("Email is required")
})

const {handleSubmit, resetForm} = useForm({
  validationSchema: schema,
})

const username = useField<string>("username")
const email = useField<string>("email")

const onSubmit = handleSubmit((values: IFormData) => {
  submitRequest(values)
})

const loading = ref<boolean>()
const success = ref<boolean>()
const errorAlert = ref<boolean>()
const errorMsg = ref<string>()

const submitRequest = (values: IFormData) => {
  loading.value = true
  api.post(`/api/auth/password/reset-request`, values, {
    withCredentials: true,
    headers: {
      Authorization: "Bearer " + document.cookie
          .split("; ")
          .find((row) => row.startsWith("access_token="))
          ?.split("=")[1]
    }
  }).then((response: AxiosResponse) => {
    loading.value = false
    success.value = true
  }).catch((error: AxiosError) => {
    loading.value = false
    errorMsg.value = error.message
  })
}

</script>

<template>
  <!--    <div class="main d-flex align-center justify-center bg-primary"-->
  <!--        :class="theme.global.name.value === 'darkTheme' ? 'genauth-background-dark' : 'genauth-background'">-->
  <AuthLayout>
    <!-- <div class="main d-flex align-center justify-center bg-primary"
    style="height: 100vh; background: linear-gradient(to bottom right, #202945, #0071ce)"> -->
    <v-sheet v-if="!loading && !success" width="450" class="mx-auto pa-12 text-center" rounded="lg" elevation="8">
      <!-- <v-img src="https://oiforroi.com/wp-content/uploads/2021/09/logo-oi.svg" /> -->
      <BrandedLogo></BrandedLogo>
      <br>
      <v-alert v-if="errorAlert" color="error">
        <p>
          There was an error submitting your request
        </p>
        <!-- <br>
        <strong>{{ errorMsg }}</strong> -->
      </v-alert>
      <br>
      <v-alert color="info"
               text="Enter the email address and username associated with your account and we'll send you a link to reset your password."></v-alert>
      <br>
      <v-text-field autofocus class="my-2" label="Username" v-model="username.value.value"
                    :error-messages="username.errorMessage.value"></v-text-field>
      <v-text-field class="my-2" label="Email" v-model="email.value.value"
                    :error-messages="email.errorMessage.value"></v-text-field>

      <v-btn color="primary" block class="mt-2" size="large" @click="onSubmit">
        <span class="mx-2">Submit</span>
      </v-btn>
      <v-btn color="primary" block class="mt-2" variant="text" to="/login">Cancel</v-btn>
    </v-sheet>
    <v-sheet width="450" class="mx-auto pa-12 text-center" rounded="lg" elevation="8" v-else-if="loading">
      <v-progress-circular :size="100" :width="8" color="primary" indeterminate></v-progress-circular>
    </v-sheet>
    <v-sheet width="450" class="mx-auto pa-12 text-center" rounded="lg" elevation="8"
             v-else-if="success && !loading">
      <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112"></v-icon>
      <h2 class="text-h5 mb-6">Password Change Request Sent!</h2>
      <p class="mb-4 text-medium-emphasis text-body-2">Please check your email.
      </p>
    </v-sheet>
  </AuthLayout>
  <!--    </div>-->
  <!--    <ThemeToggleFab></ThemeToggleFab>-->
</template>